import React from 'react'
export function List({ items, showAll = false }) {
  let _items = items
  if (!showAll) {
    _items = _items.slice(0, 3)
  }

  const listItems = _items.map((item, index) => {
    return <li key={index}>{item}</li>
  })

  return <>{_items.length > 0 ? <ul>{listItems}</ul> : null}</>
}
